export enum ElementDirection {
  ltr = 'ltr',
  rtl = 'rtl',
  auto = 'auto',
}
